import { AddressLinkDropdownPreview } from '@Components/AddressLinkDropdownPreview';
import { LinkedFieldWithLayoutSettings } from '@Components/LinkedFieldWithLayoutSettings';
import { addressColumns } from '@Constants/TableColumns';
import { type ApiAddress, type ApiOrder, EnumFrontendLayoutSetting } from '@Model';
import { FrameEditAddress } from '@Modules/Stammdaten';
import {
    type AsyncStateUpdate,
    Grid,
    GridColumns,
    type IGuiBinder,
    TextInput,
    useLinkedField,
    useLinkProperty,
    useProp,
    useTranslate,
} from '@synqo/frontend-component-library';

interface IProps {
    binder: IGuiBinder<ApiOrder>;
    baseApiObjectPath: string;
    requestUpdateState: AsyncStateUpdate<ApiOrder>;
}

// @ai-generated 2026-10-22T10:53:17+00:00 by matthias.gessinger@synqony.com using Claude Sonnet 5.5
export function OrderMoreDetails({ binder, baseApiObjectPath, requestUpdateState }: IProps) {
    const i18n = useTranslate('');

    const linkPickupSite = useLinkedField<ApiOrder, ApiAddress>(
        baseApiObjectPath,
        'pickup_site',
        FrameEditAddress,
        true,
        requestUpdateState,
    );
    const linkDeliverySite = useLinkedField<ApiOrder, ApiAddress>(
        baseApiObjectPath,
        'delivery_site',
        FrameEditAddress,
        true,
        requestUpdateState,
    );
    const linkCarrier = useLinkedField<ApiOrder, ApiAddress>(
        baseApiObjectPath,
        'carrier',
        FrameEditAddress,
        true,
        requestUpdateState,
    );

    const pickupSiteField = useLinkProperty(binder, linkPickupSite.linkApi);
    const deliverySiteField = useLinkProperty(binder, linkDeliverySite.linkApi);
    const carrierField = useLinkProperty(binder, linkCarrier.linkApi);
    const poReferenceField = useProp(binder, 'po_reference');

    return (
        <Grid>
            <GridColumns spans={[3, 3, 3, 3]}>
                <LinkedFieldWithLayoutSettings<ApiAddress>
                    layoutSettingsContext={EnumFrontendLayoutSetting.AddressesTableLayout}
                    {...pickupSiteField}
                    {...linkPickupSite.events}
                    columns={addressColumns}
                    label={i18n('Herkunft')}
                    dropdownPreview={AddressLinkDropdownPreview}
                />
                <LinkedFieldWithLayoutSettings<ApiAddress>
                    layoutSettingsContext={EnumFrontendLayoutSetting.AddressesTableLayout}
                    {...deliverySiteField}
                    {...linkDeliverySite.events}
                    columns={addressColumns}
                    label={i18n('Empfänger')}
                    dropdownPreview={AddressLinkDropdownPreview}
                />
                <LinkedFieldWithLayoutSettings<ApiAddress>
                    layoutSettingsContext={EnumFrontendLayoutSetting.AddressesTableLayout}
                    {...carrierField}
                    {...linkCarrier.events}
                    columns={addressColumns}
                    label={i18n('Beförderer')}
                    dropdownPreview={AddressLinkDropdownPreview}
                />
                <TextInput {...poReferenceField} label={i18n('Bestellnummer')} />
            </GridColumns>
        </Grid>
    );
}
